module.exports = __webpack_public_path__ + "r-v3/img/highlighter_white.1839ad6d.svg";